import { ProductAvailabilityData } from '@/data/types/ProductAvailabilityData';

export type BayDataType = {
	aisle: string;
	area: string;
	bay: string;
};
export const getBayData = (data: any, currentStoreId: string): BayDataType => {
	let bayData: any = null;
	bayData = {
		aisle: data?.[`x_itemlocation.${currentStoreId}.aisle`]
			? data[`x_itemlocation.${currentStoreId}.aisle`]
			: '',
		area: data?.[`x_itemlocation.${currentStoreId}.description`]
			? data[`x_itemlocation.${currentStoreId}.description`]
			: '',
		bay: data?.[`x_itemlocation.${currentStoreId}.bay`]
			? data[`x_itemlocation.${currentStoreId}.bay`]
			: '',
	};

	if (bayData.aisle.trim() === '' || bayData.area.trim() === '' || bayData.bay.trim() === '') {
		bayData = null;
	}

	return bayData;
};

/**
 * Set default inventory data
 *
 * @param physicalStoreUniqueId
 * @param partNumber
 * @param catentryId
 * @param physicalStoreName
 * @param search
 * @returns
 */
export const useDefaultStoreInventoryData = (
	physicalStoreUniqueId: string,
	partNumber: string,
	catentryId: string,
	physicalStoreName: string,
	search?: number
): ProductAvailabilityData => ({
	status: false,
	storeName: physicalStoreName,
	x_AvailableQuantityInMarket: '0.00',
	availableQuantity: '0.0',
	availabilityDateTime: '',
	physicalStoreName,
	productId: catentryId,
	unitOfMeasure: 'EA',
	inventoryStatus: 'Unavailable',
	physicalStoreId: physicalStoreUniqueId,
	search,
	partNumber,
	x_NextAvailableInventoryDate: '',
	x_UniqueId: '1',
	x_itemFulFillmentType: 'Store',
});
